import React from "react";
import Card from "./Card";

const PressCards = () => {
  return (
    <section className="bg-gray-100 py-8" id="press">
      <div className="container mx-auto flex flex-wrap pt-4 pb-12">
        <h3 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">
          Presse & Links
        </h3>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
        </div>

        <div className="w-full p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="2 Minuten 2 Millionen"
            link="https://www.puls4.com/2-minuten-2-millionen/staffel-7/videos/Beitraege/Getsby-im-Pitch-805619"
            imgSrc={require("./../images/press/2min2mio.jpg")}
            text="getsby im Pitch"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Austria's Next Top Start-up 2018"
            link="https://futurezone.at/start-ups/getsby-ist-austrias-next-top-start-up-2018/400149156"
            imgSrc={require("./../images/press/AustriasNextTopStartup2018.png")}
            text="getsby ist Austria's Next Top Start-up 2018"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="#glaubandich-Challenge"
            link="https://www.trendingtopics.at/getsby-glaubandich-wien-2019/"
            imgSrc={require("./../images/press/GlaubAnDich2019Finalist.png")}
            text="Das FinTech getsby zieht ins Finale der #glaubandich-Challenge
                ein"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Hitradio Ö3"
            link="https://oe3.orf.at/stories/2989541/"
            imgSrc={require("./../images/press/Hitradio_Oe3c.png")}
            text="Mit Gratis-App im Lokal bestellen und zahlen"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Food Start-Up 2018"
            link="https://lebensmittelpraxis.de/industrie-aktuell/22329-food-start-up-2018-die-besten-food-start-ups-2018-stehen-fest-2018-09-19-09-18-43.html"
            imgSrc={require("./../images/press/FoodStartup2018.png")}
            text="Die besten Food Start-ups 2018 stehen fest"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="ProSieben"
            link="https://www.prosieben.at/tv/galileo/videos/224-nie-mehr-auf-den-kellner-warten-eine-neue-app-macht-s-moeglich-clip"
            imgSrc={require("./../images/press/ProSieben_Logo_final_c.png")}
            text="Nie mehr auf den Kellner warten: Eine neue App macht's möglich!"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="falstaff"
            link="https://www.falstaff.at/nd/neue-app-fuer-kuerzere-wartezeiten-im-restaurant/"
            imgSrc={require("./../images/press/Falstaff_final-c.png")}
            text="Neue App für kürzere Wartezeiten im Restaurant"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Kurier"
            link="https://www.pressreader.com/austria/kurier-3402/20190806/281595242153360"
            imgSrc={require("./../images/press/kurier-c.png")}
            text={`Handy ersetzt "Herr Ober!"`}
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="futurezone"
            link="https://futurezone.at/start-ups/mit-dieser-app-muss-man-nie-mehr-im-lokal-auf-den-kellner-warten/400564376"
            imgSrc={require("./../images/press/futurezoneLogoC.png")}
            text="Mit dieser App muss man nie mehr im Lokal auf den Kellner warten"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Trending Topics"
            link="https://www.trendingtopics.at/getsby-app/"
            imgSrc={require("./../images/press/TrendingTopics-c.png")}
            text={`getsby: „Wir wollten am Anfang ohne Investment starten und uns
                zuerst beweisen“`}
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Hogapage"
            link="https://www.hogapage.at/nachrichten/netzwelt/it-software/bestellungen-im-lokal-per-handy-ordern/"
            imgSrc={require("./../images/press/HogaPage-c.png")}
            text="Bestellungen im Lokal per Handy ordern"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Sputnik"
            link="https://de.sputniknews.com/technik/20190822325638376-getsby-app-stressfrei-restaurant-besuchen/"
            imgSrc={require("./../images/press/Sputnik_logo_c.png")}
            text="Nie wieder auf den Kellner warten: App aus Österreich nimmt
                Bestellungen auf"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Bezirks Blätter"
            link="https://www.meinbezirk.at/eisenstadt/c-lokales/kein-warten-auf-den-kellner-mehr_a3592545"
            imgSrc={require("./../images/press/Bezirksblätter-c.png")}
            text="Kein Warten auf den Kellner mehr"
          />
        </div>
      </div>
    </section>
  );
};

export default PressCards;
